import { ASSETS } from "@/lib/assets";

const ITEMS = [
  "Varmepumpe service",
  "Etterisolering",
  "Vindtetting",
  "Kledning",
  "Vinduer & dører",
  "Garasjeporter",
  "Terrasser",
  "Energirådgivning",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative py-10 border-y hairline overflow-hidden bg-[hsl(var(--hs-bg-2))]" data-testid="marquee">
      <div className="flex marquee-track gap-12 whitespace-nowrap will-change-transform">
        {row.map((label, i) => (
          <div key={`${label}-${i}`} className="flex items-center gap-12 text-2xl sm:text-3xl font-semibold text-white/55">
            <img src={ASSETS.logoIcon} alt="" loading="lazy" decoding="async" className="w-7 h-7 shrink-0" />
            <span className="tracking-tight">{label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
